import heroImage from "../assets/shooting-range-hero.webp";
import logoImage from "../assets/omega-logo.webp";
import michalisImage from "../assets/michalis-portrait.webp";
import sotirisImage from "../assets/sotiris-portrait.webp";
import editorialImage from "../assets/editorial-range.webp";

export type NavigationItem = {
  label: string;
  path: string;
};

export type Trainer = {
  name: string;
  certification: string;
  image: string;
  imageAlt: string;
};

export type Location = {
  title: string;
  details: string[];
  directionsUrl: string;
  embedUrl: string;
  mapTitle: string;
};

export type FaqItem = {
  question: string;
  answer: string;
};

export const assets = {
  logo: logoImage,
  hero: heroImage,
  editorial: editorialImage,
};

export const navigation: NavigationItem[] = [
  { label: "Ο Σύλλογος", path: "/o-syllogos" },
  { label: "Τοποθεσίες", path: "/topothesies" },
  { label: "Εκπαιδευτές", path: "/ekpaideftes" },
  { label: "Ερωτήσεις", path: "/erotiseis" },
  { label: "Επικοινωνία", path: "/epikoinonia" },
];

export const hero = {
  title: "Αθλητικός Σκοπευτικός Όμιλος Ωμέγα",
  text: "Ο ΑΣΟ Ωμέγα ιδρύθηκε το 2006 με κύριο στόχο την προώθηση της Αθλητικής Σκοποβολής και τη δυνατότητα σε φίλους του αθλήματος να γνωρίσουν και να ασχοληθούν με ένα από τα αρχαιότερα αθλήματα.",
  cta: "Επικοινωνήστε μαζί μας",
};

export const aboutParagraphs = [
  "Ο Αθλητικός Σκοπευτικός Όμιλος (ΑΣΟ) Ωμέγα ιδρύθηκε το 2006, με κύριο στόχο την προώθηση της Αθλητικής Σκοποβολής, κάνοντας εφικτή την επιθυμία πολλών φίλων να ασχοληθούν με ένα από τα αρχαιότερα αθλήματα.",
  "Είναι μέλος της Σκοπευτικής Ομοσπονδίας Ελλάδος – ΣΚ.Ο.Ε., του επίσημου αθλητικού οργάνου της Γενικής Γραμματείας Αθλητισμού για τη Σκοποβολή, με αριθμό αναγνώρισης ΦΙ04.",
  "Υποστηρίζει αγωνίσματα για πυροβόλα όπλα — πιστόλια, περίστροφα και τυφέκια — και συμμετέχει σε επίσημους αγώνες που διοργανώνει η ΣΚ.Ο.Ε. σε όλη την Ελλάδα.",
  "Ο Όμιλος διαθέτει πιστοποιημένους από τη ΣΚΟΕ εκπαιδευτές, με μεγάλη εμπειρία σε ραβδωτά πιστόλια και τυφέκια μεγάλης εμβέλειας.",
];

export const facts = [
  { label: "Έτος ίδρυσης", value: "2006" },
  { label: "Μέλος", value: "ΣΚ.Ο.Ε." },
  { label: "Αριθμός αναγνώρισης", value: "ΦΙ04" },
];

const googleMapsPlaceEmbed = (placeName: string, zoom: number) =>
  `https://www.google.com/maps?hl=el&q=${encodeURIComponent(placeName)}&z=${zoom}&iwloc=B&output=embed`;

export const locations: Location[] = [
  {
    title: "ΠΕΔΙΟ ΒΟΛΗΣ",
    details: [
      "5ο Πεδίο Βολής ΚΕΒΟΠ Χαϊδαρίου",
      "Σάββατο & Κυριακή, ωράριο 09:30 - 13:30",
    ],
    directionsUrl: "https://maps.app.goo.gl/YqW9zmsVzcfNLsRHA",
    embedUrl: googleMapsPlaceEmbed(
      "ΩΜΕΓΑ ΣΚΟΠΕΥΤΙΚΟΣ ΟΜΙΛΟΣ, 5ο Πεδίο Βολής ΚΕΒΟΠ Χαϊδαρίου",
      15,
    ),
    mapTitle: "Χάρτης — Σκοπευτήριο Αθήνα, 5ο Πεδίο Βολής ΚΕΒΟΠ Χαϊδαρίου",
  },
  {
    title: "Γραφεία Συλλόγου",
    details: [],
    directionsUrl: "https://maps.app.goo.gl/uBKykaHx9a93ZUFe9",
    embedUrl: googleMapsPlaceEmbed("Σκοπευτικος Συλλογος Ηλιουπολης ΩΜΕΓΑ", 16),
    mapTitle: "Χάρτης — Γραφεία ΑΣΟ Ωμέγα στην Ηλιούπολη",
  },
];

export const trainers: Trainer[] = [
  {
    name: "Μιχάλης Ιωάννου",
    certification: "Πιστοποιημένος ΣΚΟΕ",
    image: michalisImage,
    imageAlt: "Μιχάλης Ιωάννου, πιστοποιημένος εκπαιδευτής σκοποβολής ΣΚΟΕ στον ΑΣΟ Ωμέγα",
  },
  {
    name: "Σωτήρης Γιανναρόπουλος",
    certification: "Πιστοποιημένος ΣΚΟΕ",
    image: sotirisImage,
    imageAlt: "Σωτήρης Γιανναρόπουλος, πιστοποιημένος εκπαιδευτής σκοποβολής ΣΚΟΕ στον ΑΣΟ Ωμέγα",
  },
];

export const faqItems: FaqItem[] = [
  {
    question: "Μπορώ να γραφτώ στον σύλλογο;",
    answer:
      "Στον ΑΣΟ Ωμέγα μπορεί να γίνει μέλος οποιοσδήποτε επιθυμεί να ασχοληθεί με το άθλημα, ανεξαρτήτως ηλικίας και φύλου.",
  },
  {
    question: "Χρειάζομαι δικό μου εξοπλισμό για την προπόνηση;",
    answer:
      "Ο Όμιλος διαθέτει μεγάλη ποικιλία όπλων και πυρομαχικών κάθε διαμετρήματος για τους αθλητές που δεν διαθέτουν δικά τους όπλα. Κατά την προπόνηση παρέχει επίσης μέσα ατομικής προστασίας, όπως ωτοασπίδες και γυαλιά.",
  },
  {
    question: "Δεν έχω εμπειρία στη σκοποβολή. Είναι δύσκολο;",
    answer:
      "Οι πιστοποιημένοι από τη ΣΚΟΕ εκπαιδευτές μας διαθέτουν εμπειρία δεκαετιών στο άθλημα. Προσφέρουμε μαθήματα όλων των βαθμίδων, σε αρχάριους και έμπειρους σκοπευτές. Στα πρώτα σας βήματα Θα σας μάθουμε κανόνες ασφαλείας, την σωστή χρήση των όπλων και τους κανονισμούς των αθλημάτων.",
  },
  {
    question: "Πότε μπορώ να κάνω προπόνηση;",
    answer:
      "Τα μέλη του συλλόγου μας συγκεντρώνονται για προπόνηση και αγώνες στο 5ο Πεδίο Βολής, στο σκοπευτήριο Χαϊδαρίου, κάθε Σάββατο και Κυριακή από τις 09:30 έως τις 13:30. Μπορείτε να έρθετε οποιαδήποτε ώρα σας εξυπηρετεί, χωρίς υποχρέωση να ακολουθείτε το πρόγραμμα των άλλων αθλητών.",
  },
  {
    question: "Μπορώ να δοκιμάσω για να δω αν μου αρέσει;",
    answer:
      "Κατόπιν συνεννόησης, μπορείτε να γνωρίσετε το άθλημα της σκοποβολής από κοντά, χωρίς να είστε εγγεγραμμένοι στον Όμιλό μας. Θα χρειαστεί μόνο να σας εκδώσουμε προσωρινή άδεια διάρκειας 2 ημερών.",
  },
];

export const contact = {
  facebook: "https://www.facebook.com/omega.shooting",
  email: "info@skopovoli.gr",
  phone: "+30 6974095784",
};

export const routeMetadata: Record<string, { title: string; description: string; label: string; keywords: string[] }> = {
  "/": {
    title: "ΑΣΟ Ωμέγα | Αθλητικός Σκοπευτικός Όμιλος",
    description: hero.text,
    label: "Αρχική",
    keywords: [
      "Αθλητικός Σύλλογος Σκοποβολής",
      "Αθλητικός Σύλλογος Όμιλος",
      "Σκοποβολή σταθερού στόχου",
      "Προπόνηση σκοποβολής",
      "Σκοπευτήριο Αθήνα",
      "Shooting sport",
    ],
  },
  "/o-syllogos": {
    title: "Ο Σύλλογος | ΑΣΟ Ωμέγα",
    description: aboutParagraphs[0],
    label: "Ο Σύλλογος",
    keywords: ["Αθλητικός Σύλλογος Σκοποβολής", "Αθλητικός Σύλλογος Όμιλος", "Shooting sport"],
  },
  "/topothesies": {
    title: "Τοποθεσίες | ΑΣΟ Ωμέγα",
    description: "Πεδίο Βολής και Γραφεία Συλλόγου του ΑΣΟ Ωμέγα.",
    label: "Τοποθεσίες",
    keywords: ["Σκοπευτήριο Αθήνα", "Shooting range", "Προπόνηση σκοποβολής", "Ηλιούπολη"],
  },
  "/ekpaideftes": {
    title: "Εκπαιδευτές | ΑΣΟ Ωμέγα",
    description: aboutParagraphs[3],
    label: "Εκπαιδευτές",
    keywords: [
      "Μαθήματα σκοποβολής",
      "Shooting training",
      "Ασφαλής χειρισμός όπλων",
      "Σχολή σκοποβολής",
      "Μαθήματα σκοποβολής για αρχάριους και προχωρημένους",
    ],
  },
  "/erotiseis": {
    title: "Ερωτήσεις | ΑΣΟ Ωμέγα",
    description: "Συχνές ερωτήσεις για την εγγραφή και την προπόνηση στον ΑΣΟ Ωμέγα.",
    label: "Ερωτήσεις",
    keywords: ["πώς να μάθω σκοποβολή", "δοκιμή σκοποβολής", "Μαθήματα σκοποβολής", "Σχολή σκοποβολής"],
  },
  "/epikoinonia": {
    title: "Επικοινωνία | ΑΣΟ Ωμέγα",
    description: "Επικοινωνήστε με τον ΑΣΟ Ωμέγα.",
    label: "Επικοινωνία",
    keywords: ["Μαθήματα σκοποβολής", "Προπόνηση σκοποβολής", "δοκιμή σκοποβολής", "Σκοπευτήριο Αθήνα"],
  },
};
